import {
  ActiveState,
  EntityState,
  EntityStore,
  EntityUIQuery,
  EntityUIStore,
  QueryEntity,
  StoreConfig
} from "@datorama/akita"
import {ApiSystemModuleResult} from "app/Interface/Api/System/ApiSystemModule"
import {SystemModuleUiResult} from "app/Interface/ApiMapped/System/SystemModuleUi"
import produce from "immer"

export interface SystemModuleStoreProps extends EntityState<ApiSystemModuleResult, string>, ActiveState {
}

export interface SystemModuleUiStoreProps extends EntityState<SystemModuleUiResult, string>, ActiveState {

}

@StoreConfig({name: 'system.module', resettable: true, producerFn: produce})
export class SystemModuleStore extends EntityStore<SystemModuleStoreProps> {
  ui: EntityUIStore<SystemModuleUiStoreProps>

  constructor() {
    super({
      loading: undefined
    })

    this.createUIStore({}, {
      resettable: true,
      producerFn: produce
    }).setInitialEntityState({})
  }
}

export const systemModuleStore = new SystemModuleStore()

class SystemModuleQuery extends QueryEntity<SystemModuleStoreProps> {
  ui: EntityUIQuery<SystemModuleUiStoreProps>

  constructor(protected store: SystemModuleStore) {
    super(store)
    this.createUIQuery()
  }
}

export const systemModuleQuery = new SystemModuleQuery(systemModuleStore)
